import { Endpoints, Http, HttpService } from "@/infra/api";
import { ApiResponse } from "@/@types";
import { IoTChannel } from "@/domain/models/Charger";

export interface IoTChannelDTO {
  charger_id: string;
  channel_type: string;
  gpio_pin: number;
  led_count: number;
  day_mode_start: string;
  night_mode_start: string;
  brightness_idle_day: number;
  brightness_idle_night: number;
  brightness_use_day: number;
  brightness_use_night: number;
  color: string;
  enabled: boolean;
}

export interface IoTChannelRepository {
  updateIoTChannel: (
    id: string,
    params: Partial<IoTChannelDTO>
  ) => Promise<ApiResponse<IoTChannel>>;
  deleteIoTChannel: (id: string) => Promise<ApiResponse<IoTChannel>>;
}

export const IoTChannelService = (
  http: Http = HttpService()
): IoTChannelRepository => ({
  updateIoTChannel: async (id: string, params: Partial<IoTChannelDTO>) => {
    return http.put<Partial<IoTChannelDTO>, IoTChannel>(
      `${Endpoints.charger_iot_channels}/${id}`,
      params
    );
  },
  deleteIoTChannel: async (id) => {
    return http.delete<IoTChannel>(`${Endpoints.charger_iot_channels}/${id}`);
  },
});
